import type {
  MonetisationBusinessGoal,
  MonetisationPricePreference,
  MonetisationTrafficSource,
} from "@/features/tools/proToolTypes";

export const businessGoalOptions: Array<{
  value: MonetisationBusinessGoal;
  label: string;
}> = [
  { value: "lead_generation", label: "Lead generation" },
  { value: "first_sale", label: "First sale" },
  { value: "recurring_revenue", label: "Recurring revenue" },
  { value: "bonus_for_existing_offer", label: "Bonus for an existing offer" },
  { value: "client_delivery", label: "Client delivery" },
  { value: "audience_growth", label: "Audience growth" },
];

export const trafficSourceOptions: Array<{
  value: MonetisationTrafficSource;
  label: string;
}> = [
  { value: "organic_social", label: "Organic social" },
  { value: "email_list", label: "Email list" },
  { value: "paid_ads", label: "Paid ads" },
  { value: "affiliate_jv", label: "Affiliate or JV" },
  { value: "community", label: "Community" },
  { value: "webinar", label: "Webinar" },
  { value: "unknown", label: "Not sure yet" },
];

export const pricePreferenceOptions: Array<{
  value: MonetisationPricePreference;
  label: string;
}> = [
  { value: "free", label: "Free / lead magnet" },
  { value: "low_ticket", label: "Low-ticket" },
  { value: "mid_ticket", label: "Mid-ticket" },
  { value: "subscription", label: "Subscription" },
  { value: "not_sure", label: "Not sure yet" },
];
